module.exports = __webpack_public_path__ + "img/stepsv2.6994b965.png";